import actions from './actions';
import mutations from './mutations';

const photoReports = {
    namespaced: true,
    state: {
        photoReport: [],
        pagination: {
            page: 1,
            totalPages: 1
        },
        activePhotoReports: [],
        paginationActive: {
            page: 1,
            totalPages: 1
        },
        finishedPhotoReports: [],
        paginationFinished: {
            page: 1,
            totalPages: 1
        },
        images: [],
        checkDrivers: null
    },
    mutations,
    actions
};

export default photoReports;
